// Shared types and events for the quarterly wholesale tier review
// (Products > Tier review, the Dashboard alert and Settings).

/** Fired on window after a review runs or a decision is made, so counts refresh. */
export const TIER_REVIEW_CHANGED = 'hub:tier-review-changed'

export interface TierReviewChecked {
  tier: string
  min_units: number
  min_orders: number
  min_retailers: number
  max_top_retailer_pct?: number
}

export interface TierReviewMetrics {
  period?: { start: string; end: string }[]
  weeks?: number
  units?: number
  small?: number
  large?: number
  other?: number
  per_week?: number
  prev_label?: string | null
  prev_units?: number | null
  prev_per_week?: number | null
  change_pct?: number | null
  orders?: number
  retailers?: number
  top_retailer?: string | null
  top_retailer_pct?: number | null
  first_sold?: string | null
  slowing?: boolean
  checked?: TierReviewChecked[]
}

export interface TierReviewItem {
  id: number
  flavor: string
  label_name: string | null
  skus: string[]
  current_tier: string | null
  suggested_tier: string | null
  applied_tier: string | null
  is_change: boolean
  metrics: TierReviewMetrics
  reasons: string[]
  decision: 'pending' | 'approved' | 'skipped'
  decided_by: string | null
  decided_at: string | null
  sync_error: string | null
}

export interface TierReviewSummary {
  id: number
  quarter_start: string
  quarter_end: string
  label: string
  created_at: string
  created_by: string | null
  run_type: string | null
  items: number
  changes: number
  pending: number
  approved: number
  skipped: number
}

export interface TierReviewData {
  due: { quarter_start: string; quarter_end: string; label: string; review_id: number | null }
  reviews: TierReviewSummary[]
  review: TierReviewSummary | null
  items: TierReviewItem[]
}

export interface TierReviewStatus {
  review_id: number | null
  quarter: string
  pending: number
}

export interface TierThresholds {
  min_units: number
  min_orders: number
  min_retailers: number
}

export interface TierReviewSettings {
  core: TierThresholds & { max_top_retailer_pct: number }
  limited: TierThresholds
  trend_guard_pct: number
}

export const TIER_ORDER = ['Core', 'Limited', 'Special Order']
